import React, { useEffect, useState } from 'react' 
import { TextField, Box, MenuItem, Button, Typography, Alert, Popover, Stack, IconButton} from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import SingleLineImageListUpdate from '../Components/ImageListUpdate';
import PropTypes from 'prop-types';
import addDecimal from '../Components/addDecimal';
import GradientCircularProgress from '../Components/GradientCircularProgress';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';





const Update = (props) => {
    let compTemp = props.comps['driverApps']
    let compTemp2 = compTemp.concat(props.comps['backSeatApps'])
    let compsTemp = compTemp2.concat(props.comps['bookingApps'])
    let compsNew = [];
    let ids = {}

    
    
    compsTemp.forEach(obj=> {
        if (!ids[obj.name]){
            ids[obj.name] = true;
            compsNew.push(obj);
        }
    });

    
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id2 = open ? 'simple-popover' : undefined;


    const [anchorEl2, setAnchorEl2] = React.useState(null);

    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
    };

    const handleClose2 = () => {
        setAnchorEl2(null);
    };

    const open2 = Boolean(anchorEl2);
    const id3 = open ? 'simple-popover2' : undefined;


    const [affiliate, setAffiliate] = useState('');
    const [affiliateID, setAffiliateID] = useState(0);
    const [versionInfo, setVersionInfo] = useState('');
    const [aboutApp, setAboutApp] = useState('');
    const [appleLink, setAppleLink] = useState('');
    const [googleLink, setGoogleLink] = useState('');
    const [app, setApp] = useState('');
    const [appType, setAppType] = useState('');
    const [apps, setApps] = useState([]);

    const [id, setId] = useState(0);
    const [bgPhoto, setBgPhoto] = useState(null);
    const [appLogo, setAppLogo] = useState(null);
    const [screenshots, setScreenshots] = useState([]);
    const [screenshotList, setScreenshotList] = useState([]);

    const [updateComplete, setUpdateComplete] = useState(false);
    const [updateError, setUpdateError] = useState(false);
    const [updateErrorMessage, setUpdateErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (sessionStorage.getItem("app")){
            const x = JSON.parse(sessionStorage.getItem("app"))
            setApp(x)
            setApps([x])
            setAppType(x.appType)
            setAffiliate(x.name)
            setAffiliateID(x.iAffiliateID)
            setId(x.key);
            setScreenshotList(x.screenshots)
            setVersionInfo(x.versionInfo);
            setAboutApp(x.aboutApp);
            setAppleLink(x.appleLink);
            setGoogleLink(x.googleLink);        
        }
    }, [])

    function handleAffiliateChange(event) {
        setApp('')
        setAppType('')
        setAffiliate(event)
        setAffiliateID(event.iAffiliateID)

        let typeList = []
        compsTemp.forEach((app) => {
            if(app.name === event){
                typeList.push(app)
            }
        })
        setAffiliateID(typeList[0].iAffiliateID)
        setApps(typeList)
    }

    function handleAppChange(event) {
        setApp('');
        let currApp = ''
        apps.forEach((newApp) => {
            if(newApp.appType === event){
                currApp = newApp
            }
        })
        setApp(currApp);
        setAppType(currApp.appType)
        sessionStorage.setItem("app", JSON.stringify(currApp))
        setId(currApp.key);
        setScreenshotList(currApp.screenshots)
        setVersionInfo(currApp.versionInfo);
        setAboutApp(currApp.aboutApp);
        setAppleLink(currApp.appleLink);
        setGoogleLink(currApp.googleLink);
    }

    async function handleUpdate(e){
        const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        const today = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
        e.preventDefault();
        const APILinksFetch = await fetch('/APILinks.json')
        const APILinks = await APILinksFetch.json()
    
        let data = new FormData();
        if(bgPhoto != null){
            data.append('BGPhoto', bgPhoto)
            app.BGPhoto = (`/pages/appPages/${app.appType}/${affiliate}/BGPhoto.png`)
        }
        if(appLogo != null){
            data.append('appLogo', appLogo)
            app.appLogo = (`/pages/appPages/${app.appType}/${affiliate}/logo.png`)
        }

        if(screenshots.length !== 0) {
          for(const file of screenshots){
            data.append('screenshots', file)
          }
        }

        setIsLoading(true);
        if (bgPhoto === null && appLogo === null && screenshots.length === 0){
            const response = await fetch(APILinks['updateApp'] + new URLSearchParams({ 
                id: Number(id),
                iAffiliateID: (Number(affiliateID)),
                affiliateName: affiliate,
                appType: app.appType,
                versionNo: addDecimal(parseFloat(app.versionNo)),
                versionInfo: versionInfo,
                releaseDate: today,
                navLink: app.navLink,
                downloadLink: app.downloadLink,
                BGPhoto: app.BGPhoto,
                appLogo: app.appLogo,
                isTesting: app.isTesting,
                aboutApp: aboutApp,
                appleLink: appleLink,
                googleLink: googleLink,
            }).toString(),
            {
            method: 'PUT'
            })
            const updateData = await response.json()
            if (updateData['message'] === 'Completed'){
                setUpdateComplete(true)
            }
            else{
                setUpdateErrorMessage(updateData['message'])
                setUpdateError(true)
            }
        }
        else{
            const response = await fetch(APILinks['updateApp'] + new URLSearchParams({ 
                id: Number(id),
                iAffiliateID: (Number(affiliateID)),
                affiliateName: affiliate,
                appType: app.appType,
                versionNo: addDecimal(parseFloat(app.versionNo)),
                versionInfo: versionInfo,
                releaseDate: today,
                navLink: app.navLink,
                downloadLink: app.downloadLink,
                BGPhoto: app.BGPhoto,
                appLogo: app.appLogo,
                isTesting: app.isTesting,
                aboutApp: aboutApp,
                appleLink: appleLink,
                googleLink: googleLink,
            }).toString(),
            {
            method: 'PUT',
            body: data
            })
            const updateData = await response.json()
            if (updateData['message'] === 'Completed'){
                setUpdateComplete(true)
            }
            else{
                setUpdateErrorMessage(updateData['message'])
                setUpdateError(true)
            }
        }
        sessionStorage.setItem("app", "")
    }

    async function handleDeleteRecord(e){
        const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        const today = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
        e.preventDefault();
        const APILinksFetch = await fetch('/APILinks.json')
        const APILinks = await APILinksFetch.json()
        const response = await fetch(APILinks['deleteRecord'] + new URLSearchParams({ 
            id: Number(id),
            iAffiliateID: (Number(affiliateID)),
            affiliateName: affiliate,
            appType: app.appType,
            versionNo: addDecimal(parseFloat(app.versionNo)),
            versionInfo: versionInfo,
            releaseDate: today,
            navLink: app.navLink,
            downloadLink: app.downloadLink,
            BGPhoto: app.BGPhoto,
            appLogo: app.appLogo,
            isTesting: app.isTesting,
            aboutApp: aboutApp,
            appleLink: appleLink,
            googleLink: googleLink,
        }).toString(),
        {
        method: 'POST'
        })
        const updateData = await response.json()
        if (updateData['message'] === 'Deleted'){
            sessionStorage.setItem("app", "");
            window.location.reload(false);
        }
        else{
            setUpdateErrorMessage(updateData['message'])
            setUpdateError(true)
        }
        sessionStorage.setItem("app", "")
    }

    async function handleDeleteUpload(e){
        const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        const today = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
        e.preventDefault();
        const APILinksFetch = await fetch('/APILinks.json')
        const APILinks = await APILinksFetch.json()
        const response = await fetch(APILinks['deleteUpload'] + new URLSearchParams({ 
            id: Number(id),
            iAffiliateID: (Number(affiliateID)),
            affiliateName: affiliate,
            appType: app.appType,
            versionNo: addDecimal(parseFloat(app.versionNo)),
            versionInfo: versionInfo,
            releaseDate: today,
            navLink: app.navLink,
            downloadLink: app.downloadLink,
            BGPhoto: app.BGPhoto,
            appLogo: app.appLogo,
            isTesting: app.isTesting,
            aboutApp: aboutApp,
            appleLink: appleLink,
            googleLink: googleLink,
        }).toString(),
        {
        method: 'POST'
        })
        const updateData = await response.json()
        if (updateData['message'] === 'Deleted'){
            sessionStorage.setItem("app", "");
            window.location.reload(false);
        }
        else{
            setUpdateErrorMessage(updateData['message'])
            setUpdateError(true)
        }
        sessionStorage.setItem("app", "")
    }

    function handleUpdateClose(){
        setUpdateComplete(false)
        setIsLoading(false)
    }

    function handleErrorClose(){
        setUpdateError(false);
        setIsLoading(false);
    }

    return (
        <div className='mainPage'>
            {!updateComplete && 
            <Box
                component="form"
                autoComplete='off'
                className='formContainer'
                onSubmit={handleUpdate}
            > 
                <Typography variant="h4">
                    Update an existing upload
                </Typography>
                
                <CssTextField name={'affiliate'} 
                    InputLabelProps={{
                        component: 'span',
                    }} 
                    select
                    value={affiliate}
                    required 
                    onChange={(event) => handleAffiliateChange(event.target.value)} 
                    label='Affiliate' 
                    variant='outlined' 
                    size='normal' 
                    margin='normal'>
                    {compsNew.map((option) => (
                        <MenuItem key={option.name} value={option.name}>
                            {option.name}
                        </MenuItem>
                    ))}
                </CssTextField>

                {affiliate && (
                    <>
                        <CssTextField 
                            name="affiliateID"
                            InputLabelProps={{
                                component: 'span',
                            }}  
                            inputProps={{readOnly: true}}
                            value={affiliateID} 
                            label='Affiliate ID' 
                            variant='outlined' 
                            size='normal' 
                            margin='normal' 
                        />
                        <br />
                        <CssTextField name={'appType'} 
                            InputLabelProps={{
                                component: 'span',
                            }} 
                            select 
                            value={appType} 
                            required 
                            onChange={(event) => handleAppChange(event.target.value)} 
                            label='App Type' 
                            variant='outlined' 
                            size='normal' 
                            margin='normal'>
                            {apps.map((option) => (
                                <MenuItem key={option.appType} value={option.appType}>
                                    {option.appType}
                                </MenuItem>
                            ))}
                        </CssTextField>
                    </>
                )}

                {app && (
                    <>
                        <CssTextField 
                            name="versionNo"
                            InputLabelProps={{
                                component: 'span',
                                shrink: true
                            }}  
                            inputProps={{readOnly: true}}
                            value={app.versionNo} 
                            label='Version #' 
                            variant='outlined' 
                            size='normal' 
                            margin='normal' 
                        />
                        <br/>
                        <CssTextField 
                            name="versionInfo"
                            InputLabelProps={{
                                component: 'span',
                                shrink: true
                            }}  
                            value={versionInfo} 
                            label='Version Info' 
                            variant='outlined' 
                            size='normal' 
                            margin='normal' 
                            fullWidth
                            multiline
                            onChange={(event) => {setVersionInfo(event.target.value)}}
                        />
                        
                        <CssTextField 
                            name={'bgPhoto'} 
                            sx={{marginTop: '3%'}} 
                            InputLabelProps={{shrink: true}} 
                            type='file' 
                            label='Background Photo' 
                            onChange={(event) => {setBgPhoto(event.target.files[0])}}
                        />

                        <CssTextField name={'appLogo'} 
                            sx={{marginTop: '3%', marginBottom: '5%'}} 
                            InputLabelProps={{shrink: true}} 
                            type='file' 
                            label='App Logo' 
                            onChange={(event) => {setAppLogo(event.target.files[0])}}
                        />
                        < br/>
                        <SingleLineImageListUpdate screenshotList={screenshotList} setComps={props.setComps} app={app} />
                        
                        <CssTextField name={'screenshots'} 
                            sx={{marginTop: '3%'}} 
                            InputLabelProps={{shrink: true}} 
                            inputProps={{multiple: true}} 
                            type='file' 
                            label='Screenshots' 
                            onChange={(event) => {setScreenshots(Array.from(event.target.files))}}
                        />

                        { app.aboutApp ? 
                            <CssTextField name={'aboutApp'} sx={{marginTop: '3%'}} 
                                InputLabelProps={{shrink: true}} 
                                fullWidth 
                                multiline
                                label='About this app' 
                                variant='outlined' 
                                size='normal' 
                                margin='normal'
                                value={aboutApp}
                                onChange={(event) => setAboutApp(event.target.value)}
                            />
                            :
                            <CssTextField name={'aboutApp'} sx={{marginTop: '3%'}} 
                            fullWidth 
                            multiline
                            label='About this app' 
                            variant='outlined' 
                            size='normal' 
                            margin='normal'
                            value={aboutApp}
                            onChange={(event) => setAboutApp(event.target.value)}
                        />
                        }

                        { app.appleLink ? 
                            <CssTextField name={'appleLink'} 

                            InputLabelProps={{
                                shrink: true
                            }}  
                            
                            sx={{marginTop: '3%'}} 
                            label='Apple Store Link' 
                            value = {appleLink}
                            variant='outlined' 
                            size='normal' 
                            margin='normal' 
                            onChange={(event) => setAppleLink(event.target.value)}
                            /> 
                            : 
                            <CssTextField name={'appleLink'} 
                            sx={{marginTop: '3%'}} 
                            label='Apple Store Link' 
                            value = {appleLink}
                            variant='outlined' 
                            size='normal' 
                            margin='normal' 
                            onChange={(event) => setAppleLink(event.target.value)}
                            /> 
                        }
                        

                        { app.googleLink ? 
                            <CssTextField name={'googleLink'} 

                                InputLabelProps={{
                                    shrink: true
                                }}  
                                value={googleLink}
                                sx={{marginTop: '3%', marginLeft: '1%'}} 
                                label='Play Store Link' 
                                variant='outlined' 
                                size='normal' 
                                margin='normal'
                                onChange={(event) => setGoogleLink(event.target.value)}
                            />
                            :
                            <CssTextField name={'googleLink'}
                                sx={{marginTop: '3%', marginLeft: '1%'}} 
                                label='Play Store Link' 
                                variant='outlined' 
                                size='normal' 
                                margin='normal'
                                onChange={(event) => setGoogleLink(event.target.value)}
                                value={googleLink}
                            />
                        }

                        <br />
                        
                        { 
                            !isLoading?
                            <Button 
                            type="submit" 
                            sx={buttonStyle} 
                            variant="outlined" 
                            className='upload' 
                            startIcon={<CloudUploadOutlinedIcon />}>
                                Update
                            </Button> 
                            :
                            (!updateError ? 
                            <Stack className="stack" alignItems="center" sx={{width: '100%', height: '100%'}}> 
                                <GradientCircularProgress />
                            </Stack>
                            :
                            <Alert sx={{width: '50%', margin: 'auto'}} variant="outlined" severity='error' 
                            action={
                                <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    handleErrorClose();
                                }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }> 
                                {updateErrorMessage}
                            </Alert> )
                        }

                        <div>
                            <Button 
                                type="button"
                                sx={buttonStyleDelete} 
                                variant="outlined" 
                                className='upload' 
                                onClick={handleClick}
                                startIcon={<DeleteForeverOutlinedIcon/>}>
                                    Delete
                            </Button>

                            <Popover
                                disableScrollLock={true}
                                id={id2}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                sx={{display: "flex", justifyContent: "center", alignItems: 'center'}}
        
                            >
                                <Typography align = 'center' sx={{ p: 1, }}>Do you want to delete this?<br/>This will remove all data</Typography>
                                <Button sx={{padding: 'auto',}} onClick={(event) => {handleDeleteRecord(event)}}>Yes</Button>
                            </Popover>
                        </div>
                        
                        <div>
                            <Button 
                                type="button"
                                sx={buttonStyleDelete} 
                                variant="outlined" 
                                className='upload' 
                                onClick={handleClick2}
                                startIcon={<DeleteForeverOutlinedIcon/>}>
                                    Delete recent upload
                            </Button>

                            <Popover
                                disableScrollLock={true}
                                id={id3}
                                open={open2}
                                anchorEl={anchorEl2}
                                onClose={handleClose2}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                sx={{display: "flex", justifyContent: "center", alignItems: 'center'}}
        
                            >
                                <Typography align = 'center' sx={{ p: 1, }}>Do you want to delete this recent app?<br/>This will remove all data</Typography>
                                <Button sx={{padding: 'auto',}} onClick={(event) => {handleDeleteUpload(event)}}>Yes</Button>
                            </Popover>
                        </div>


                    </>
                )}

            </Box> }

            {updateComplete && 
                <Alert sx={{width: '50%', margin: 'auto'}} variant="outlined" severity='success'
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            handleUpdateClose();
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                    }
                > 
                  Update completed
                </Alert> 
            }

        </div>
    )
    


}

export default Update;



const CssTextField = styled(TextField)({
    minWidth: '125px;',
   '& .MuiInput': {overflow: 'wrap'},
    '& label.Mui-focused': {
    color: '#141419',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#141419',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#717171',
    },
    '&:hover fieldset': {
      borderColor: '#141419',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0A21C0',
    },
  },
  })

  const buttonStyle = {
    margin: 'auto',
    marginTop: '15px',
    marginBottom: '15px',
    width: 'auto',
    height: 'auto',
    color: 'whitesmoke',
    fontSize: '15px',
    boxShadow: "5",
    backgroundColor: '#141619',
    borderColor: '#141419',
    "&:hover": {
      backgroundColor: 'green',
      borderColor: 'green',
      WebkitTextFillColor: 'white',
      boxShadow: "15",
    },
    "&::after":{
      WebkitTextFillColor: 'white'
    }
    }

    const buttonStyleDelete = {
        margin: 'auto',
        marginTop: '15px',
        marginBottom: '15px',
        width: 'auto',
        height: 'auto',
        color: 'whitesmoke',
        fontSize: '15px',
        boxShadow: "5",
        backgroundColor: '#141619',
        borderColor: '#141419',
        "&:hover": {
          backgroundColor: 'red',
          borderColor: 'red',
          WebkitTextFillColor: 'white',
          boxShadow: "15",
        },
        "&::after":{
          WebkitTextFillColor: 'white'
        }
        }

Update.propTypes ={
   comps: PropTypes.any,
   setComps: PropTypes.func
}